export default "__VITE_ASSET__WdwPQWnl__"